import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import HeaderNav from "./components/HeaderNav";
import TrustFooter from "./components/TrustFooter";
import WhatsAppFloat from "./components/WhatsAppFloat";
import NewHomePage from "./pages/marketing/NewHomePage";
import PracticesPage from "./pages/marketing/PracticesPage";
import PracticeDetailPage from "./pages/marketing/PracticeDetailPage";
import TechnologyPage from "./pages/marketing/TechnologyPage";
import AboutPage from "./pages/marketing/AboutPage";
import ContactPage from "./pages/marketing/ContactPage";
import InsightsPage from "./pages/InsightsPage";
import ArticlePage from "./pages/ArticlePage";
import AdminPage from "./pages/AdminPage";
import PortalLogin from "./pages/portal/PortalLogin";
import PortalLayout from "./pages/portal/PortalLayout";
import PortalHome from "./pages/portal/PortalHome";
import PortalTeam from "./pages/portal/PortalTeam";
import PortalAccount from "./pages/portal/PortalAccount";
import PortalNetwork from "./pages/portal/PortalNetwork";
import { Toaster } from "./components/ui/sonner";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const lenis = window.__lenis;
    if (hash) {
      let attempts = 0;
      const timer = setInterval(() => {
        attempts += 1;
        const target = document.querySelector(hash);
        if (target) {
          clearInterval(timer);
          if (lenis) lenis.scrollTo(target, { offset: -110 });
          else target.scrollIntoView({ behavior: "smooth" });
        } else if (attempts > 20) {
          clearInterval(timer);
        }
      }, 120);
      return () => clearInterval(timer);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const appRoute = pathname.startsWith("/portal") || pathname.startsWith("/admin");
  return (
    <div className="min-h-screen bg-parchment-base text-forest-deep">
      {!appRoute && <HeaderNav />}
      <Routes>
        <Route path="/" element={<NewHomePage />} />
        <Route path="/practices" element={<PracticesPage />} />
        <Route path="/practice/:slug" element={<PracticeDetailPage />} />
        <Route path="/technology" element={<TechnologyPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/insights/:slug" element={<ArticlePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/portal/login" element={<PortalLogin />} />
        <Route path="/portal" element={<PortalLayout />}>
          <Route index element={<PortalHome />} />
          <Route path="network" element={<PortalNetwork />} />
          <Route path="team" element={<PortalTeam />} />
          <Route path="account" element={<PortalAccount />} />
        </Route>
      </Routes>
      {!appRoute && (
        <>
          <TrustFooter />
          <WhatsAppFloat />
        </>
      )}
      <Toaster richColors position="bottom-center" />
    </div>
  );
}

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;
    const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <Shell />
    </BrowserRouter>
  );
}

export default App;
